const WhatWeDoScreen = () => {


    return (
        <p>What We Do here</p>
    )
}

export default WhatWeDoScreen